"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementType = exports.UserTag = exports.RoleEnum = exports.paymentStatusOptions = exports.paymentTypeOptions = exports.enrollmentMethodOptions = exports.preferredSpeakingLanguageOptions = exports.precoursePerformanceTagOptions = exports.genderOptions = exports.placementStatusOptions = exports.jobTypeOptions = exports.jobStatusOptions = exports.collegeDepartmentOptions = exports.masterCollegeDegreeOptions = exports.bachelorCollegeDegreeOptions = exports.collegeDegreeOptions = exports.homeStateOptions = exports.preferredCodingLanguageOptions = exports.otherCodingSkillsOptions = void 0;
var otherCodingSkillsOptions;
(function (otherCodingSkillsOptions) {
  otherCodingSkillsOptions["Spring"] = "Spring";
  otherCodingSkillsOptions["Angular"] = "Angular";
  otherCodingSkillsOptions["Ruby_on_rails"] = "Ruby on rails";
  otherCodingSkillsOptions["PHP"] = "PHP";
  otherCodingSkillsOptions["NET"] = ".NET";
  otherCodingSkillsOptions["Django"] = "Django";
  otherCodingSkillsOptions["Flask"] = "Flask";
  otherCodingSkillsOptions["Springboot"] = "Springboot";
  otherCodingSkillsOptions["Hibernate"] = "Hibernate";
  otherCodingSkillsOptions["Selenium_Testing"] = "Selenium/Testing";
  otherCodingSkillsOptions["Salesforce"] = "Salesforce";
  otherCodingSkillsOptions["Service_Now"] = "Service Now";
  otherCodingSkillsOptions["Node"] = "Node";
  otherCodingSkillsOptions["React"] = "React";
  otherCodingSkillsOptions["Vue"] = "Vue";
  otherCodingSkillsOptions["Express"] = "Express";
  otherCodingSkillsOptions["Mongo_DB"] = "Mongo DB";
  otherCodingSkillsOptions["SQL"] = "SQL";
  otherCodingSkillsOptions["AWS"] = "AWS";
  otherCodingSkillsOptions["HTML"] = "HTML";
  otherCodingSkillsOptions["CSS"] = "CSS";
  otherCodingSkillsOptions["Wordpress"] = "Wordpress";
  otherCodingSkillsOptions["basic_dsa"] = "Basic DSA";
  otherCodingSkillsOptions["intermediate_dsa"] = "Intermediate DSA";
  otherCodingSkillsOptions["advanced_dsa"] = "Advanced DSA";
  otherCodingSkillsOptions["oops"] = "OOPS";
  otherCodingSkillsOptions["os"] = "OS";
  otherCodingSkillsOptions["networking"] = "Networking";
  otherCodingSkillsOptions["java"] = "Java";
  otherCodingSkillsOptions["cpp"] = "C++";
  otherCodingSkillsOptions["python"] = "Python";
  otherCodingSkillsOptions["javascript"] = "Javascript";
})(otherCodingSkillsOptions = exports.otherCodingSkillsOptions || (exports.otherCodingSkillsOptions = {}));
var preferredCodingLanguageOptions;
(function (preferredCodingLanguageOptions) {
  preferredCodingLanguageOptions["Java"] = "Java";
  preferredCodingLanguageOptions["Python"] = "Python";
  preferredCodingLanguageOptions["Javascript"] = "Javascript";
  preferredCodingLanguageOptions["CPP_C"] = "C/C++";
})(preferredCodingLanguageOptions = exports.preferredCodingLanguageOptions || (exports.preferredCodingLanguageOptions = {}));
var homeStateOptions;
(function (homeStateOptions) {
  homeStateOptions["Andhra_Pradesh"] = "Andhra Pradesh";
  homeStateOptions["Arunachal_Pradesh"] = "Arunachal Pradesh";
  homeStateOptions["Assam"] = "Assam";
  homeStateOptions["Bihar"] = "Bihar";
  homeStateOptions["Chhattisgarh"] = "Chhattisgarh";
  homeStateOptions["Goa"] = "Goa";
  homeStateOptions["Gujarat"] = "Gujarat";
  homeStateOptions["Haryana"] = "Haryana";
  homeStateOptions["Himachal_Pradesh"] = "Himachal Pradesh";
  homeStateOptions["Jharkhand"] = "Jharkhand";
  homeStateOptions["Karnataka"] = "Karnataka";
  homeStateOptions["Kerala"] = "Kerala";
  homeStateOptions["Madhya_Pradesh"] = "Madhya Pradesh";
  homeStateOptions["Maharashtra"] = "Maharashtra";
  homeStateOptions["Manipur"] = "Manipur";
  homeStateOptions["Meghalaya"] = "Meghalaya";
  homeStateOptions["Mizoram"] = "Mizoram";
  homeStateOptions["Nagaland"] = "Nagaland";
  homeStateOptions["Odisha"] = "Odisha";
  homeStateOptions["Punjab"] = "Punjab";
  homeStateOptions["Rajasthan"] = "Rajasthan";
  homeStateOptions["Sikkim"] = "Sikkim";
  homeStateOptions["Tamil_Nadu"] = "Tamil Nadu";
  homeStateOptions["Telangana"] = "Telangana";
  homeStateOptions["Tripura"] = "Tripura";
  homeStateOptions["Uttar_Pradesh"] = "Uttar Pradesh";
  homeStateOptions["Uttarakhand"] = "Uttarakhand";
  homeStateOptions["West_Bengal"] = "West Bengal";
  homeStateOptions["Andaman_and_Nicobar_Islands"] = "Andaman and Nicobar Islands";
  homeStateOptions["Chandigarh"] = "Chandigarh";
  homeStateOptions["Dadra_Diu"] = "Dadra & Nagar Haveli and Daman & Diu";
  homeStateOptions["Delhi"] = "Delhi";
  homeStateOptions["Jammu_and_Kashmir"] = "Jammu and Kashmir";
  homeStateOptions["Lakshadweep"] = "Lakshadweep";
  homeStateOptions["Puducherry"] = "Puducherry";
  homeStateOptions["Ladakh"] = "Ladakh";
})(homeStateOptions = exports.homeStateOptions || (exports.homeStateOptions = {}));
var collegeDegreeOptions;
(function (collegeDegreeOptions) {
  collegeDegreeOptions["BTech_BE"] = "BTech./BE";
  collegeDegreeOptions["MTech_ME"] = "MTech./ME";
  collegeDegreeOptions["BCA"] = "BCA";
  collegeDegreeOptions["MCA"] = "MCA";
  collegeDegreeOptions["BBA"] = "BBA";
  collegeDegreeOptions["MBA"] = "MBA";
  collegeDegreeOptions["BSc"] = "BSc.";
  collegeDegreeOptions["MSc"] = "MSc";
  collegeDegreeOptions["BCom"] = "BCom";
  collegeDegreeOptions["BA"] = "BA";
  collegeDegreeOptions["MA"] = "MA";
  collegeDegreeOptions["BEd"] = "B.Ed.";
  collegeDegreeOptions["LLB"] = "LLB";
  collegeDegreeOptions["BArch"] = "BArch.";
  collegeDegreeOptions["BDes"] = "BDes.";
  collegeDegreeOptions["CA"] = "CA";
  collegeDegreeOptions["BJMC"] = "BJMC";
  collegeDegreeOptions["BHM"] = "BHM";
  collegeDegreeOptions["Other"] = "Other";
})(collegeDegreeOptions = exports.collegeDegreeOptions || (exports.collegeDegreeOptions = {}));
var bachelorCollegeDegreeOptions;
(function (bachelorCollegeDegreeOptions) {
  bachelorCollegeDegreeOptions["BTech_BE"] = "BTech./BE";
  bachelorCollegeDegreeOptions["BCA"] = "BCA";
  bachelorCollegeDegreeOptions["BBA"] = "BBA";
  bachelorCollegeDegreeOptions["BSc"] = "BSc.";
  bachelorCollegeDegreeOptions["BCom"] = "BCom";
  bachelorCollegeDegreeOptions["BA"] = "BA";
  bachelorCollegeDegreeOptions["BEd"] = "BE,d.";
  bachelorCollegeDegreeOptions["LLB"] = "LLB";
  bachelorCollegeDegreeOptions["BArch"] = "BArch.";
  bachelorCollegeDegreeOptions["BDes"] = "BDes.";
  bachelorCollegeDegreeOptions["CA"] = "CA";
  bachelorCollegeDegreeOptions["BJMC"] = "BJMC";
  bachelorCollegeDegreeOptions["BHM"] = "BHM";
  bachelorCollegeDegreeOptions["Other"] = "Other";
})(bachelorCollegeDegreeOptions = exports.bachelorCollegeDegreeOptions || (exports.bachelorCollegeDegreeOptions = {}));
var masterCollegeDegreeOptions;
(function (masterCollegeDegreeOptions) {
  masterCollegeDegreeOptions["MTech_ME"] = "MTech./ME";
  masterCollegeDegreeOptions["MCA"] = "MCA";
  masterCollegeDegreeOptions["MBA"] = "MBA";
  masterCollegeDegreeOptions["MSc"] = "MSc";
  masterCollegeDegreeOptions["Other"] = "Other";
})(masterCollegeDegreeOptions = exports.masterCollegeDegreeOptions || (exports.masterCollegeDegreeOptions = {}));
var collegeDepartmentOptions;
(function (collegeDepartmentOptions) {
  collegeDepartmentOptions["CSE"] = "Computer Science/CSE/Other CS related branch";
  collegeDepartmentOptions["Electrical"] = "Electrical/Other electrical related branches";
  collegeDepartmentOptions["Chemical_Engineering"] = "Chemical Engineering";
  collegeDepartmentOptions["Civil"] = "Civil";
  collegeDepartmentOptions["Mechanical"] = "Mechanical/Other mechanics related branch";
  collegeDepartmentOptions["Aeronautical"] = "Aeronautical/Aerospace";
  collegeDepartmentOptions["Biotech"] = "Biotech/Biomedical";
  collegeDepartmentOptions["Ceramic"] = "Ceramic";
  collegeDepartmentOptions["Communications"] = "Communications";
  collegeDepartmentOptions["Physics"] = "Physics";
  collegeDepartmentOptions["Chemistry"] = "Chemistry";
  collegeDepartmentOptions["Mathematics"] = "Mathematics";
  collegeDepartmentOptions["English"] = "English/Literature";
  collegeDepartmentOptions["Metallurgical"] = "Metallurgical/Mining";
  collegeDepartmentOptions["Textile"] = "Textile";
  collegeDepartmentOptions["Others"] = "Others";
  collegeDepartmentOptions["Agriculture"] = "Agriculture";
  collegeDepartmentOptions["IT"] = "IT";
})(collegeDepartmentOptions = exports.collegeDepartmentOptions || (exports.collegeDepartmentOptions = {}));
var jobStatusOptions;
(function (jobStatusOptions) {
  jobStatusOptions["Working_Professional"] = "Working_Professional";
  jobStatusOptions["Student"] = "Student";
  jobStatusOptions["Unemployed"] = "Unemployed";
})(jobStatusOptions = exports.jobStatusOptions || (exports.jobStatusOptions = {}));
var jobTypeOptions;
(function (jobTypeOptions) {
  jobTypeOptions["Coding_Related"] = "Coding Related";
  jobTypeOptions["Not_Coding_Related"] = "Not Coding Related";
})(jobTypeOptions = exports.jobTypeOptions || (exports.jobTypeOptions = {}));
var placementStatusOptions;
(function (placementStatusOptions) {
  placementStatusOptions["Placed"] = "Placed";
  placementStatusOptions["Autoplaced"] = "Autoplaced";
  placementStatusOptions["Not_placed"] = "Not placed";
})(placementStatusOptions = exports.placementStatusOptions || (exports.placementStatusOptions = {}));
var genderOptions;
(function (genderOptions) {
  genderOptions["Male"] = "Male";
  genderOptions["Female"] = "Female";
  genderOptions["Others"] = "Others";
})(genderOptions = exports.genderOptions || (exports.genderOptions = {}));
var precoursePerformanceTagOptions;
(function (precoursePerformanceTagOptions) {
  precoursePerformanceTagOptions["Bad"] = "Bad";
  precoursePerformanceTagOptions["Average"] = "Average";
  precoursePerformanceTagOptions["Good"] = "Good";
})(precoursePerformanceTagOptions = exports.precoursePerformanceTagOptions || (exports.precoursePerformanceTagOptions = {}));
var preferredSpeakingLanguageOptions;
(function (preferredSpeakingLanguageOptions) {
  preferredSpeakingLanguageOptions["English"] = "English";
  preferredSpeakingLanguageOptions["Hindi"] = "Hindi";
  preferredSpeakingLanguageOptions["Bengali"] = "Bengali";
  preferredSpeakingLanguageOptions["Gujarati"] = "Gujarati";
  preferredSpeakingLanguageOptions["Kannada"] = "Kannada";
  preferredSpeakingLanguageOptions["Malayalam"] = "Malayalam";
  preferredSpeakingLanguageOptions["Marathi"] = "Marathi";
  preferredSpeakingLanguageOptions["Tamil"] = "Tamil";
  preferredSpeakingLanguageOptions["Telugu"] = "Telugu";
})(preferredSpeakingLanguageOptions = exports.preferredSpeakingLanguageOptions || (exports.preferredSpeakingLanguageOptions = {}));
var enrollmentMethodOptions;
(function (enrollmentMethodOptions) {
  enrollmentMethodOptions["PaP"] = "PaP";
  enrollmentMethodOptions["Moneyback"] = "Moneyback";
  enrollmentMethodOptions["Upfront"] = "Upfront";
})(enrollmentMethodOptions = exports.enrollmentMethodOptions || (exports.enrollmentMethodOptions = {}));
var paymentTypeOptions;
(function (paymentTypeOptions) {
  paymentTypeOptions["loan"] = "loan";
  paymentTypeOptions["oneshot"] = "oneshot";
})(paymentTypeOptions = exports.paymentTypeOptions || (exports.paymentTypeOptions = {}));
var paymentStatusOptions;
(function (paymentStatusOptions) {
  paymentStatusOptions["booking_received"] = "booking received";
  paymentStatusOptions["total_received"] = "total received";
  paymentStatusOptions["not_initiated"] = "not initiated";
  paymentStatusOptions["initiated"] = "initiated";
  paymentStatusOptions["process_stopped"] = "process stopped";
})(paymentStatusOptions = exports.paymentStatusOptions || (exports.paymentStatusOptions = {}));
var RoleEnum;
(function (RoleEnum) {
  RoleEnum["PrecourseUser"] = "precourse-user";
  RoleEnum["OnboardedUser"] = "onboarded-user";
  RoleEnum["MainCourseUser"] = "maincourse-user";
  RoleEnum["Mentor"] = "mentor";
  RoleEnum["Instructor"] = "instructor";
  RoleEnum["Admin"] = "admin";
  RoleEnum["BatchManager"] = "batch-manager";
})(RoleEnum = exports.RoleEnum || (exports.RoleEnum = {}));
var UserTag;
(function (UserTag) {
  UserTag["UNASSIGNED"] = "Un-assigned";
  UserTag["ALARMING"] = "Alarming";
  UserTag["POOR"] = "Poor";
  UserTag["AVERAGE"] = "Average";
  UserTag["ONPOINT"] = "On Point";
  UserTag["LEADING"] = "Leading";
})(UserTag = exports.UserTag || (exports.UserTag = {}));
var AnnouncementType;
(function (AnnouncementType) {
  AnnouncementType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  AnnouncementType["HEADER"] = "HEADER";
})(AnnouncementType = exports.AnnouncementType || (exports.AnnouncementType = {}));